import { useCallback, useRef, useState } from "react";
import UploadZone from "../../../Components/Upload/UploadZone";
import DatePicker from "react-datepicker";
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import { Alert, Spinner } from "react-bootstrap";
import { UploadAllIn } from "../../../api/Api";
import { useQuery } from "react-query";

export default function CargaAllIn() {

  const [date, setDate] = useState(null)

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const formData = useRef(null);
  const yearUpload = useRef(null);
  const fileNameForMessage = useRef("");
  const [isError, setIsError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(null);


  registerLocale('es', es);

  const {
    refetch: refetchUpload,
    isFetching: isFetchingUpload,
  } = useQuery("uploadAllIn", () => UploadAllIn(yearUpload.current, formData.current),
    {
      enabled: false,
      onSuccess: (res) => {
        if (res.data.success) {
          setIsSuccess(true);
        } else {
          setIsError(true);
        }
        clearForm();
      },
      onError: () => {
        clearForm();
        setIsError(true);
      }
    })


  const customDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length === 0) {
      return;
    }
    setFile(acceptedFiles[0]);
    setFileName(acceptedFiles[0].path)
  }, []);

  const upload = useCallback(() => {
    setIsError(false);
    setIsSuccess(false);
    const formDataFile = new FormData();
    formDataFile.append('file', file);
    formData.current = formDataFile;
    fileNameForMessage.current = fileName;
    refetchUpload();
  }, [file, fileName, refetchUpload]);

  const handleDateChangeRaw = useCallback((e) => {
    e.preventDefault();
  }, []);

  const clearForm = useCallback(() => {
    yearUpload.current = null;
    formData.current = null;
    setFile(null);
    setFileName("");
    setDate(null);
  }, []);

  return (
    <>
      <div className="row mb-7">
        <div className="col-12">
          {isSuccess && (
            <Alert key='info' variant='success' className='mb-0'>
              <b>Carga Exitosa:</b> El archivo "{fileNameForMessage.current}" ha sido cargado con éxito.
            </Alert>
          )}

          {isError && (
            <Alert key='info' variant='success' className='mb-0'>
              <b>Error:</b> No se pudo cargar el archivo "{fileNameForMessage.current}".
            </Alert>
          )}
        </div>
      </div>
      <div className="row mb-8">
        <div className="align-items-end col-6 d-flex justify-content-between">
          <div style={{ width: '80%' }}>
            <div className="fw-bold fs-7 text-gray-600 mb-1">Año Carga All In:</div>
            <DatePicker
              className="form-control form-control-transparent pe-5"
              locale="es"
              selected={date}
              onChange={(value) => {
                setDate(value);
                yearUpload.current = value.getFullYear();
              }}
              dateFormat="yyyy"
              showYearPicker
              portalId="root-date-picker-portal"
              onChangeRaw={handleDateChangeRaw}
            />
          </div>
          <button
            type="button"
            className="btn btn-primary btn-md d-flex ms-2"
            disabled={!file || !yearUpload.current || isFetchingUpload}
            onClick={upload} >
            Cargar
            {isFetchingUpload &&
              <Spinner animation="border" variant="secondary" role="status" className="loading d-flex justify-content-center superadmin-spinner"></Spinner>
            }
          </button>
        </div>
      </div>
      <div className='row'>
        <div className="col-12">
          <UploadZone
            onDrop={customDrop}
            fileName={fileName}
            isLoading={false}
            showMessageUploadLink={false}
            fileAccept={'xlsx'}
            container={'w-100'}
          >
          </UploadZone>
        </div>
      </div>
    </>
  )
}